import { Injectable } from '@angular/core';
import { map, mergeMap } from 'rxjs/operators';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import * as ArrearsListingWidgetActions from '../actions/arrears-listing-widget.actions';
import { TableHttpService } from "@shared/table/services/table-http.service";
import { filter } from 'rxjs/operators';

@Injectable()
export class ArrearsListingWidgetEffects {
  constructor(
    private readonly actions: Actions,
    private readonly tableHttpService: TableHttpService
  ) { }

  loadArrearsListingWidgetDetails = createEffect(() => this.actions.pipe(
    ofType(ArrearsListingWidgetActions.loadArrearsTable),
    filter(action => action.viewName !== undefined),
    mergeMap(action => {

      const viewName =  (action.viewName === "ArrearsListingWidget" ? 'ArrearsListing' : 'ArrearsTenantListing');
      return this.tableHttpService.getTable(viewName, action.key)
        .pipe(map(table => {
          if (viewName === 'ArrearsListing') {
            return ArrearsListingWidgetActions.loadArrearsTableComplete({ dashboardWidgetId: action.dashboardWidgetId, table: table });
          } else {
            return ArrearsListingWidgetActions.loadArrearsTenantTableComplete({ dashboardWidgetId: action.dashboardWidgetId, table: table });
          }
        }));

    })

  ));
}
